import { ErrorSchema, RJSFValidationError } from "@rjsf/utils";

export class ExtraErrorHelper {
  public static toExtraError(message: string): ErrorSchema {
    return {
      __errors: [message]
    } as ErrorSchema;
  }

  public static sanitizeErrors = (errors: RJSFValidationError[]): RJSFValidationError[] => {
    return errors.map((error) => {
      if (error.name === "required") {
        error.message = "Bitte füllen Sie das Pflichtfeld aus.";
      }
      return error;
    });
  };
}
